import SideBySideBoardViewsComponentTabsComponent from "./side-by-side-board-views-component-tabs-component";
import SideBySideBoardViewsComponentTabsConfig from "./side-by-side-board-views-component-tabs-config";
import SideBySideBoardViewsComponentTabsAdvancedConfig from "./side-by-side-board-views-component-tabs-advanced-config";

export default {
  SideBySideBoardViewsComponentTabsComponent,
  SideBySideBoardViewsComponentTabsConfig,
  SideBySideBoardViewsComponentTabsAdvancedConfig
};
